import * as React from 'react';
import { styled } from '@mui/material/styles';
import MUITabs from '@mui/material/Tabs';
import MUITab from '@mui/material/Tab';

export const Tabs = styled(MUITabs)({
    borderBottom: '1px solid #83828099',
    height: '40px',
    minHeight: '40px',
    marginBottom: '12px',
    '& .MuiTabs-scroller': {
        height: '40px',
    },
    '& .MuiTabs-indicator': {
        backgroundColor: '#838280',
    },
});

export const Tab = styled(MUITab)({
    height: '40px',
    minHeight: '40px',
    padding: '6px 20px',
    fontSize: '14px',
    fontWeight: '700',
    lineHeight: '16px',
    opacity: 0.6,
    '&.Mui-selected': {
        color: '#838280',
        opacity: 1,
    },
});


